import type { UseFormSetValue } from 'react-hook-form';
import type z from 'zod';
import type { ProjectSearchFormType } from '../_models/projects-search.js';
import {
  shouldShowIndicatorDataNatureType,
  shouldShowIndicatorKeywordCheckbox,
  shouldShowIndicatorTerm,
} from './activity-indicator-conditions';
import type { indicatorTypeEnum } from './enum.js';

export const controlActivityIndicatorByType = ({
  setValue,
  value,
}: {
  // nullは初期状態でもあるため明示的に'reset'を追加している。
  value: z.infer<typeof indicatorTypeEnum> | 'reset';
  setValue: UseFormSetValue<ProjectSearchFormType>;
}) => {
  if (shouldShowIndicatorKeywordCheckbox(value).result !== 'enable') {
    setValue('hasOnlyQualitativeIndicator', false);
    setValue('indicatorKeywordSearchOnlyTitleAndDescription', false);
  }
  if (!shouldShowIndicatorTerm(value, false)) {
    setValue('indicatorTerm', null);
  }
  if (shouldShowIndicatorDataNatureType(value, false).result !== 'enable') {
    setValue('indicatorDataNatureType', null);
  }
};
